/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform User API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeneratePasswordRequest
 */
export interface GeneratePasswordRequest {
    /**
     * The user ID
     * @type {string}
     * @memberof GeneratePasswordRequest
     */
    userId: string;
}

export function GeneratePasswordRequestFromJSON(json: any): GeneratePasswordRequest {
    return GeneratePasswordRequestFromJSONTyped(json, false);
}

export function GeneratePasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneratePasswordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
    };
}

export function GeneratePasswordRequestToJSON(value?: GeneratePasswordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
    };
}


